import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAttributes, IAugmentedJQuery, IController, IModule, IOnChangesObject, IQService} from "angular";
import moment from "moment";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {WebNavigasjon} from "../../tjenester/WebNavigasjon";
import {MøteRessurs} from "../../../felles/tjenester/ressurser/MøteRessurs";
import HtmlDiff from 'htmldiff-js';
import {gettextCatalog} from "angular-gettext";
import {GruppeRessurs} from "../../../felles/tjenester/ressurser/GruppeRessurs";
import {GruppeMedlemRessurs} from "../../../felles/tjenester/ressurser/GruppeMedlemRessurs";
import {BrukerRessurs} from "../../../felles/tjenester/ressurser/BrukerRessurs";
import {Språk} from "../../../felles/tjenester/i18n/Spraak";
import {Debugger} from "debug";
import {Autentisering} from "../../../felles/tjenester/Autentisering";

const debug: Debugger = require('debug')('EndringshendelseKontroller');

const css = require('./endringshendelse.scss');

export class EndringshendelseKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wkEndringshendelse', {
                bindings: {
                    hendelse: '<'
                },
                controller: EndringshendelseKontroller.forInjisering(),
                template: require('./endringshendelse.html'),
                transclude: true
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$attrs,
            regNavn.ng.$element,
            regNavn.ng.$q,
            regNavn.gettext.gettextCatalog,
            GruppeRessurs.regNavn,
            GruppeMedlemRessurs.regNavn,
            BrukerRessurs.regNavn,
            MøteRessurs.regNavn,
            WebNavigasjon.regNavn,
            Autentisering.regNavn,
            EndringshendelseKontroller
        ]
    }

    constructor(private $attr: IAttributes,
                private $element: IAugmentedJQuery,
                private $q: IQService,
                private gettextCatalog: gettextCatalog,
                private gruppeRes: GruppeRessurs,
                private medlemRes: GruppeMedlemRessurs,
                private brukerRes: BrukerRessurs,
                private møteRes: MøteRessurs,
                private webNavigasjon: WebNavigasjon,
                private autentisering: Autentisering) {
    }

    modell: Modell;
    // for å bruke enum i html
    datatyper = Datatype;


    stoetterGaaTil() {
        return this.modell.stoetterGaaTil;
    }

    gaaTilEntitet() {
        console.debug('gaaTilEntitet', this.modell.hendelse);
        if (!this.stoetterGaaTil()) return;

        if (this.modell.erEpost) {
            if (this.modell.epostMottaker.gruppeId !== null && this.modell.epostMottaker.medlemId !== null)
                return this.webNavigasjon.gåTilMedlem(this.modell.epostMottaker.gruppeId, this.modell.epostMottaker.medlemId);

            // hvis det kun er bruker, så er det en super-admin som ser hendelsen eller bruker selv.
            // ville vært fint å ha knapp til bruker her...
            return false;
        }

        //gå til møte.avstemning ved avstemningsresultatEndret hendelse
        if (this.modell.hendelse.subEndringstype === l.SubEndringstype.avstemningsresultatEndret) {
            return this.møteRes.finnMøteIdTilknyttetDeltaker(this.modell.hendelse.entitetReferanse.id).$promise
              .then(møteId => this.webNavigasjon.gåTilMøteAvstemning(møteId.id));
        }
        //gå til gruppens medlem-side
        if (this.modell.hendelse.entitetReferanse.type.toLowerCase() === 'medlem')
            return this.webNavigasjon.gåTilMedlem(this.modell.hendelse.gruppeId, this.modell.hendelse.entitetReferanse.id);
        //ved rolleperiode gå til gruppens medlem-side
        if (this.modell.hendelse.entitetReferanse.type.toLowerCase() === 'rolleperiode')
            return this.webNavigasjon.gåTilMedlem(this.modell.hendelse.gruppeId, this.finnForelder(this.modell.hendelse, 'medlem').id);

        if(this.modell.hendelse.entitetReferanse.type.toLowerCase() === 'aksjebeholdning')
            return this.webNavigasjon.gåTilGruppeAksjeeierbok(this.modell.hendelse.gruppeId);

        if(this.modell.hendelse.entitetReferanse.type.toLowerCase() === 'aksjeeier')
            return this.webNavigasjon.gåTilGruppeAksjeeierbok(this.modell.hendelse.gruppeId);

        if(this.modell.hendelse.entitetReferanse.type.toLowerCase() === 'aksjeklasse')
            return this.webNavigasjon.gåTilGruppeAksjeeierbok(this.modell.hendelse.gruppeId);


        //gå til standard side for entitet knyttet til hendelse
        return this.webNavigasjon.gåTilEntitetRef(this.modell.hendelse.entitetReferanse);
    }

    gaaTilEntitetLenkeTekst() {
        if (!this.stoetterGaaTil()) return "";
        const type = this.modell.hendelse.entitetReferanse.type.toLowerCase();
        switch (type){
            case 'møte':
            case 'møtedeltaker':
            case 'avstemning':
                return this.gettextCatalog.getString("Vis møtet");
            case 'sak':
                return this.gettextCatalog.getString("Vis sak");
            case 'protokollførtmøtedeltaker':
                return this.gettextCatalog.getString("Vis protokoll");
            case 'dokument':
                return this.gettextCatalog.getString("Vis dokument");
            case 'medlem':
            case 'rolleperiode':
                return this.gettextCatalog.getString("Vis medlem");
            case 'aksjeeier':
            case 'aksjebeholdning':
                return this.gettextCatalog.getString("Vis aksjeeierbok")
            default:
                return this.gettextCatalog.getString("Vis");
        }
    }

    toggleDetaljerForHendelse() {
        if (!this.modell.visDetaljer) {
            this.modell.initDetaljer(this)
        }
        this.modell.visDetaljer = !this.modell.visDetaljer;
    }

    setEpostIframeSrc(hendelseId: string, epostUrl: string) {
        let iframe: IAugmentedJQuery = this.$element.find("#epost-" + hendelseId);
        iframe.attr('src', epostUrl);
    }

    private finnForelder(hendelse: l.EndringshendelseModell, type: String): l.EntitetReferanseModell {
        return hendelse.foreldre.find(forelder => forelder.type.toLowerCase() == type.toLowerCase());
    }

    private formaterMoete(verdi) {
        return verdi.nummer + " " + moment(verdi.dato.start).format("L");
    }

    private oversettTilgangsrollerArray(verdi) {
        const self = this;
        return verdi === null ? [] : _.transform(verdi, function (result, rolle) {
            result.push(self.oversettTilgangsrolle(rolle));
            return true;
        }, []);
    }

    private oversettAutentiseringsmetoderArray(verdi) {
        const self = this;
        return verdi === null ? [] : _.transform(verdi, function (result, metode) {
            result.push(self.oversettAutentiseringsmetoder(metode));
            return true;
        }, []);
    }


    private oversettVerdiDersomDetTrengs(dataType: Datatype, verdi) {
        switch (dataType) {
            case Datatype.invitasjonsstatus: return this.oversettInvitasjonsstatus(verdi);
            case Datatype.deltakerstatus: return this.oversettDeltakerstatus(verdi);
            case Datatype.medlemstatus: return this.oversettMedlemstatus(verdi);
            case Datatype.protokollfortDeltakerstatus: return this.oversettProtokollfortDeltakerstatus(verdi);
            case Datatype.signeringsstatus: return this.oversettSigneringStatus(verdi);
            case Datatype.oppgavestatus: return this.oversettOppgavestatus(verdi);
            case Datatype.temastatus: return this.oversettTemastatus(verdi);
            case Datatype.tillatteAutentiseringsmetoder: return this.oversettAutentiseringsmetoderArray(verdi);
            case Datatype.spraak: return this.oversettSpraak(verdi);
            case Datatype.boolean: return this.oversettBoolean(verdi);
            case Datatype.avstemningalternativer: return verdi === null ? [] : verdi;
            case Datatype.tilgangsroller: return this.oversettTilgangsrollerArray(verdi);
            case Datatype.moete: return this.formaterMoete(verdi);
            case Datatype.dato: return EndringshendelseKontroller.formaterDatoOgKlokkeslett(verdi);
            case Datatype.aksjeeiertype: return this.oversettAksjeeiertype(verdi);
            default:
                debug(`ikke-håndtert dataType: ${dataType}, returnerer verdi: ${verdi}`, verdi);
                return verdi;
        }
    }

    private oversettAksjeeiertype(verdi) {
        if(verdi === l.Aksjeeiertype.organisasjon) {
            return this.gettextCatalog.getString("Organisasjon")
        }

        return this.gettextCatalog.getString("Privatperson")
    }


    private oversettBoolean(verdi) {
        /// endringslogg boolean true
        if (verdi) return this.gettextCatalog.getString("Ja");
        /// endringslogg boolean false
        return this.gettextCatalog.getString("Nei");
    }

    private oversettInvitasjonsstatus(verdi) {
        const status: l.Invitasjonsstatus = l.Invitasjonsstatus[verdi as keyof typeof l.Invitasjonsstatus];
        switch (status) {
            case l.Invitasjonsstatus.ikke_sendt:
                /// Invitasjonsstatus.ikke_sendt
                return this.gettextCatalog.getString("Ikke sendt");
            case l.Invitasjonsstatus.sendt:
                /// Invitasjonsstatus.sendt
                return this.gettextCatalog.getString("Sendt");
            case l.Invitasjonsstatus.akseptert:
                /// Invitasjonsstatus.akseptert
                return this.gettextCatalog.getString("Godtatt");
            case l.Invitasjonsstatus.avslått:
                /// Invitasjonsstatus.avslått
                return this.gettextCatalog.getString("Avslått");
            default:
                return status;
        }
    }

    private oversettDeltakerstatus(verdi) {
        const status: l.Deltakerstatus = l.Deltakerstatus[verdi as keyof typeof l.Deltakerstatus];
        switch (status) {
            case l.Deltakerstatus.innkalling_ikke_sendt:
                /// Deltakerstatus.innkalling_ikke_sendt
                return this.gettextCatalog.getString("Ikke sendt");
            case l.Deltakerstatus.innkalling_sendt:
                /// Deltakerstatus.innkalling_sendt
                return this.gettextCatalog.getString("Sendt");
            case l.Deltakerstatus.akseptert:
                /// Deltakerstatus.akseptert
                return this.gettextCatalog.getString("Godtatt");
            case l.Deltakerstatus.avslaatt:
                /// Deltakerstatus.avslaatt
                return this.gettextCatalog.getString("Avslått");
            default:
                return status;
        }
    }

    private oversettMedlemstatus(status:l.Medlemstatus) {
        switch (status) {
            case l.Medlemstatus.normal_tilgang:
                /// Medlemstatus.normal_tilgang
                return this.gettextCatalog.getString("Normal tilgang");
            case l.Medlemstatus.tilgang_stengt:
                /// Medlemstatus.tilgang_stengt
                return this.gettextCatalog.getString("Tilgang stengt");
            case l.Medlemstatus.anonymisert:
                /// Medlemstatus.anonymisert
                return this.gettextCatalog.getString("Permanent deaktivert");
            default:
                return status;
        }
    }

    private oversettTilgangsrolle(rolle:l.TilgangsrolleMedlem) {
        return GruppeMedlemRessurs.muligeTilgangsrollerForMedlem(this.gettextCatalog)[rolle].tittel;
    }

    private oversettProtokollfortDeltakerstatus(verdi) {
        // usikker på hvorfor jeg må konvertere til ritkig enum her men ikke i oversettSigneringStatus?? men det må man ...
        const status: l.ProtokollførtDeltakerstatus = l.ProtokollførtDeltakerstatus[verdi as keyof typeof l.ProtokollførtDeltakerstatus];
        switch (status) {
            case l.ProtokollførtDeltakerstatus.deltatt:
                /// ProtokollførtDeltakerstatus.deltatt
                return this.gettextCatalog.getString("Deltatt");
            case l.ProtokollførtDeltakerstatus.forfall:
                /// ProtokollførtDeltakerstatus.forfall
                return this.gettextCatalog.getString("Forfall");
            case l.ProtokollførtDeltakerstatus.ikkeInnkalt:
                /// ProtokollførtDeltakerstatus.ikkeInnkalt
                return this.gettextCatalog.getString("Ikke innkalt");

            default:
                return status;
        }
    }

    private oversettSigneringStatus(status: l.SigneringStatus) {
        switch (status) {
            case l.SigneringStatus.ikkeAktivert:
                /// SigneringStatus.ikkeAktivert
                return this.gettextCatalog.getString("Ikke aktivert");
            case l.SigneringStatus.tilSignering:
                /// SigneringStatus.tilSignering
                return this.gettextCatalog.getString("Til signering");
            case l.SigneringStatus.delvisSignert:
                /// SigneringStatus.delvisSignert
                return this.gettextCatalog.getString("Signering påbegynt");
            case l.SigneringStatus.signert:
                /// SigneringStatus.signert
                return this.gettextCatalog.getString("Ferdig signert");
            case l.SigneringStatus.signertOgKonvoluttert:
                /// SigneringStatus.signert
                return this.gettextCatalog.getString("Ferdig signert og dokumentasjon registrert");
            case l.SigneringStatus.eksterntSignert:
                /// SigneringStatus.eksterntSignert
                return this.gettextCatalog.getString("Eksternt signert");
            default:
                return "ukjent";
        }
    }

    private oversettOppgavestatus(status: l.Oppgavestatus) {
        switch (status) {
            case l.Oppgavestatus.ikke_påbegynt:
                /// SigneringStatus.ikkeAktivert
                return this.gettextCatalog.getString("Ikke påbegynt");
            case l.Oppgavestatus.påbegynt:
                /// SigneringStatus.ikkeAktivert
                return this.gettextCatalog.getString("Påbegynt");
            case l.Oppgavestatus.utført:
                /// SigneringStatus.ikkeAktivert
                return this.gettextCatalog.getString("Utført");
            default:
                return "ukjent";
        }
    }
    private oversettAutentiseringsmetoder(metode:l.Autentiseringsmetode) {
        return this.autentisering.autentiseringsmetodenavnKort(metode);
    }

    private oversettTemastatus(status:l.Temastatus) {
        switch (status) {
            case l.Temastatus.aktiv:
                /// Temastatus.aktiv
                return this.gettextCatalog.getString('Aktivt');
            case l.Temastatus.arkivert:
                /// Temastatus.arkivert
                return this.gettextCatalog.getString('Arkivert');
            case l.Temastatus.overstyrt_til_aktiv:
                /// Temastatus.overstyrt_til_arkivert
                return this.gettextCatalog.getString('Aktivt (overstyrer gruppemal)');
            case l.Temastatus.overstyrt_til_arkivert:
                /// Temastatus.overstyrt_til_arkivert
                return this.gettextCatalog.getString('Arkivert (overstyrer gruppemal)');
            default:
                return "ukjent";
        }
    }


    private oversettSpraak(spraak) {

        if (spraak == null){
            return spraak;
        }

        if (spraak == 'nb'){
            return this.gettextCatalog.getString("Bokmål");
        }
        if (spraak == 'nn'){
            return this.gettextCatalog.getString("Nynorsk");
        }
        if (spraak == 'en'){
            return this.gettextCatalog.getString("Engelsk");
        }
        console.log("Ukjent Språk:",spraak);
        return spraak;
    }

    hentGammelOgNyVerdi(dataType: Datatype, feltEndring: l.FeltendringModell, callback: (gammelVerdi: any, nyVerdi: any) => void) {
        if (dataType == Datatype.medlemmer) {
            this.lastMedlemmerForTilgangsEndring(feltEndring.gammelVerdi, feltEndring.nyVerdi, callback);
            return;
        }
        callback(this.oversettVerdiDersomDetTrengs(dataType, feltEndring.gammelVerdi), this.oversettVerdiDersomDetTrengs(dataType, feltEndring.nyVerdi));
    }

    htmlDiff(gammelVerdi: string, nyVerdi: string):string {
        if (gammelVerdi == null)
            gammelVerdi = "";
        if (nyVerdi == null) {
            nyVerdi = "";
        }
        return HtmlDiff.execute(gammelVerdi, nyVerdi);
    }

    static datoEndret(gammelDato, nyDato) {
        if (gammelDato === nyDato) return false; // matcher hvis begge er null
        if (gammelDato === null) return true;
        if (nyDato === null) return true;
        gammelDato = this.transformBigDateToSmallerDate(gammelDato);
        nyDato = this.transformBigDateToSmallerDate(nyDato);

        return !moment(gammelDato).isSame(moment(nyDato));
    }

    static formaterDatoOgKlokkeslett(dato) {
        if (dato == null) return '';
        dato = EndringshendelseKontroller.transformBigDateToSmallerDate(dato);
        try {
            return moment(dato).format("DD-MM-YYYY HH:mm");
        } catch (e) {
            console.warn("Endringshendelse.formaterDatoOgKlokkeslett(..), feil under formatering av dato", dato, e);
            return '';
        }
    }

    // no.systemfabrikken.lederplan.delt.Dato.maxZonedDateTime er satt til dette. Den blir ikke tolket som data av js.
    private static transformBigDateToSmallerDate(dato) {
        if ("+33658-09-27T01:46:40Z" === dato) return new Date(2100, 0, 1);
        return dato
    }

    $onChanges(changes: IOnChangesObject) {
        // hendelser er statisk?
        if (changes['hendelse'].currentValue) {
            this.init( changes['hendelse'].currentValue);
        }
    }

    $onDestroy() {
        this.modell.onDestroy();
    }


    init(hendelse: l.EndringshendelseModell) {
        this.modell = new Modell(hendelse);
        this.modell.init(this);
    }

    private medlemTilEpostMottaker(medlem: l.GruppeMedlemModell): EpostMottaker {
        return {
            gruppeId: this.modell.hendelse.gruppeId,
            medlemId: medlem.id,
            brukerId: medlem.brukerId,
            navn: medlem.navn
        } as EpostMottaker;
    }

    private brukerTilEpostMottaker(bruker: l.BrukerModell): EpostMottaker {
        return {
            gruppeId: null,
            medlemId: null,
            brukerId: bruker.id,
            navn: bruker.navn
        } as EpostMottaker;
    }

    private lastMedlemmerForTilgangsEndring(gammelVerdi, nyVerdi, callback: (gamleMedlemmer: l.GruppeMedlemModell[], nyeMedlemmer: l.GruppeMedlemModell[]) => void) {

        let ider: string[] = [];

        const nyVerdiMeldemIder: string[] = this.tilArray(nyVerdi);
        nyVerdiMeldemIder.forEach(medlemId => ider.push(medlemId));

        const gammelVerdiMeldemIder: string[] = this.tilArray(gammelVerdi);
        gammelVerdiMeldemIder.forEach(medlemId => ider.push(medlemId));

        // for å fjerne duplikater.
        ider = Array.from(new Set(ider));
        this.$q.all(ider.map(id => this.medlemRes.hent(id).$promise))
            .then((medlemmer: l.GruppeMedlemModell[]) => {
                const medlemmerNy: l.GruppeMedlemModell[] = []
                const medlemmerGammel: l.GruppeMedlemModell[] = []
                medlemmer.forEach(medlem => {
                    if (nyVerdiMeldemIder.includes(medlem.id))
                        medlemmerNy.push(medlem);
                    if (gammelVerdiMeldemIder.includes(medlem.id))
                        medlemmerGammel.push(medlem);
                })
                callback(medlemmerGammel, medlemmerNy);
            });
    }

    private tilArray(verdi): [] {
        return verdi === null ? [] : verdi;
    }

    /*
     Mangler:

     Møtedeltaker-1-8-stemming se https://github.com/systemfabrikken/lederplan/issues/837
     Møtedeltaker-1-7-stemming se https://github.com/systemfabrikken/lederplan/issues/837
     */

    private datatyperOgOversettelser: { [nøkkel: string]: FeltEndringMedDataTypeOgOversettelse } = {
        /// hendelseslogg Møte-1-X-formål
        'Møte-1-X-formål': {datatype: Datatype.html, feltOversettelse: this.gettextCatalog.getString("Møtets formål")},
        /// hendelseslogg Møte-1-X-dato
        'Møte-1-X-dato': {datatype: Datatype.datoPeriode, feltOversettelse: this.gettextCatalog.getString("Møtedato")},
        /// hendelseslogg Møte-1-X-ansvarlig
        'Møte-1-X-ansvarlig': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Ansvarlig")},
        /// hendelseslogg Møte-1-X-behandlingsSted
        'Møte-1-X-behandlingsSted': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Møtested")},
        /// hendelseslogg Møte-1-X-behandlingsMåte
        'Møte-1-X-behandlingsMåte': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Behandlingsmåte")},

        /// hendelseslogg Møte-1-4-låst
        'Møte-1-4-låst': {datatype: Datatype.boolean, feltOversettelse: this.gettextCatalog.getString("Låst")},
        /// hendelseslogg Møte-1-4-låst
        'Møte-1-5-låst': {datatype: Datatype.boolean, feltOversettelse: this.gettextCatalog.getString("Låst")},

        /// hendelseslogg Møte-1-9-avstemningsperiode
        'Møte-1-9-avstemningsperiode': {datatype: Datatype.datoPeriode, feltOversettelse: this.gettextCatalog.getString("Avstemningsperiode")},
        /// hendelseslogg Møte-1-10-avstemningsperiode
        'Møte-1-10-avstemningsperiode': {datatype: Datatype.datoPeriode, feltOversettelse: this.gettextCatalog.getString("Avstemningsperiode")},
        /// hendelseslogg Møte-1-17-erProtokollPublisert
        'Møte-1-17-erProtokollPublisert': {datatype: Datatype.boolean, feltOversettelse: this.gettextCatalog.getString("Protokoll publisert")},
        /// hendelseslogg Møte-1-17-erMøtePublisert
        'Møte-1-17-erMøtePublisert': {datatype: Datatype.boolean, feltOversettelse: this.gettextCatalog.getString("Møte publisert")},

        // Møte-1-28 er endring av møteinfo i protokollen
        /// hendelseslogg Møte-1-28-dato
        'Møte-1-28-dato': {datatype: Datatype.datoPeriode, feltOversettelse: this.gettextCatalog.getString("Møtedato")},
        /// hendelseslogg Møte-1-28-behandlingsSted
        'Møte-1-28-behandlingsSted': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Møtested")},
        /// hendelseslogg Møte-1-28-behandlingsMåte
        'Møte-1-28-behandlingsMåte': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Behandlingsmåte")},


        /// hendelseslogg Møte-1-16-medlemmerUtenTilgang
        'Møte-1-16-medlemmerUtenTilgang': {datatype: Datatype.medlemmer, feltOversettelse: this.gettextCatalog.getString("Tilgang endret")},
        'Dokument-1-16-medlemmerUtenTilgang': {datatype: Datatype.medlemmer, feltOversettelse: this.gettextCatalog.getString("Tilgang endret")},
        'Sak-1-16-medlemmerUtenTilgang': {datatype: Datatype.medlemmer, feltOversettelse: this.gettextCatalog.getString("Tilgang endret")},
        'Arkivnode-1-16-medlemmerUtenTilgang': {datatype: Datatype.medlemmer, feltOversettelse: this.gettextCatalog.getString("Tilgang endret")},

        /// hendelseslogg Sak-1-X-tittel
        'Sak-1-X-tittel': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Saksnavn")},
        /// hendelseslogg Sak-1-X-beskrivelse
        'Sak-1-X-beskrivelse': {datatype: Datatype.html, feltOversettelse: this.gettextCatalog.getString("Saksbeskrivelse")},
        /// hendelseslogg Sak-1-X-ansvarlig
        'Sak-1-X-ansvarlig': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Ansvarlig")},
        /// hendelseslogg Sak-1-X-varighet
        'Sak-1-X-varighet': {datatype: Datatype.varighet, feltOversettelse: this.gettextCatalog.getString("Varighet")},
        /// hendelseslogg Sak-1-X-sakstype
        'Sak-1-X-sakstype': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Sakstype")},
        /// hendelseslogg Sak-1-X-tema
        'Sak-1-X-tema': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Tema")},
        /// hendelseslogg Sak-1-X-møte
        'Sak-1-X-møte': {datatype: Datatype.moete, feltOversettelse: this.gettextCatalog.getString("Møte")},

        /// hendelseslogg Sak-1-1-referat
        'Sak-1-1-referat': {datatype: Datatype.html, feltOversettelse: this.gettextCatalog.getString("Referat")},

        /// hendelseslogg Dokument-1-4-status
        'Dokument-1-4-status': {datatype: Datatype.signeringsstatus, feltOversettelse: this.gettextCatalog.getString("Signeringsstatus")},
        /// hendelseslogg Dokument-1-5-status
        'Dokument-1-5-status': {datatype: Datatype.signeringsstatus, feltOversettelse: this.gettextCatalog.getString("Signeringsstatus")},
        /// hendelseslogg Dokument-1-18-status
        'Dokument-1-19-status': {datatype: Datatype.signeringsstatus, feltOversettelse: this.gettextCatalog.getString("Signeringsstatus")},

        /// hendelseslogg Beslutning-1-X-beskrivelse
        'Beslutning-1-X-beskrivelse': {datatype: Datatype.html, feltOversettelse: this.gettextCatalog.getString("Beskrivelse")},
        /// hendelseslogg Beslutning-1-X-tittel
        'Beslutning-1-X-tittel': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Beslutningstittel")},

        /// hendelseslogg Oppgave-1-X-frist
        'Oppgave-1-X-frist': {datatype: Datatype.dato, feltOversettelse: this.gettextCatalog.getString("Frist")},
        /// hendelseslogg Oppgave-1-X-tittel
        'Oppgave-1-X-tittel': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Oppgavetittel")},
        /// hendelseslogg Oppgave-1-X-beskrivelse
        'Oppgave-1-X-beskrivelse': {datatype: Datatype.html, feltOversettelse: this.gettextCatalog.getString("Beskrivelse")},
        /// hendelseslogg Oppgave-1-X-ansvarlig
        'Oppgave-1-X-ansvarlig': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Ansvarlig")},
        /// hendelseslogg Oppgave-1-X-status
        'Oppgave-1-X-status': {datatype: Datatype.oppgavestatus, feltOversettelse: this.gettextCatalog.getString("Oppgavestatus")},

        /// hendelseslogg Medlem-1-X-invitasjonsStatus
        'Medlem-1-X-invitasjonsStatus': {datatype: Datatype.invitasjonsstatus, feltOversettelse: this.gettextCatalog.getString("Invitasjonsstatus")},
        /// hendelseslogg
        'Medlem-1-X-medlemsrolle': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Rolle")},
        //Medlem.harTilgang ble erstattet med Medlem.status i sak #1159
        /// hendelseslogg Medlem-1-X-harTilgang
        'Medlem-1-X-harTilgang': {datatype: Datatype.boolean, feltOversettelse: this.gettextCatalog.getString("Tilgang")},
        /// hendelseslogg Medlem-1-X-status
        'Medlem-1-X-status': {datatype: Datatype.medlemstatus, feltOversettelse: this.gettextCatalog.getString("Tilgangsstatus")},
        /// hendelseslogg Medlem-1-X-tilgangsroller
        'Medlem-1-X-tilgangsroller': {datatype: Datatype.tilgangsroller, feltOversettelse: this.gettextCatalog.getString("Tilgangsroller")},

        /// hendelseslogg Medlem-1-X-tilgangsroller
        'RollePeriode-1-X-periode': {datatype: Datatype.datoPeriode, feltOversettelse: this.gettextCatalog.getString("Perioden rollen gjelder for")},

        /// hendelseslogg Medlem-1-25-bruker
        'Medlem-1-25-bruker': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Bruker")},

        /// hendelseslogg Gruppe-1-X-tittel
        'Gruppe-1-X-tittel': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Gruppenavn")},
        /// hendelseslogg Gruppe-1-X-organisasjonsnavn
        'Gruppe-1-X-organisasjonsnavn': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Organisasjonsnavn")},
        /// hendelseslogg Gruppe-1-X-møtenavn
        'Gruppe-1-X-møtenavn': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Møtenavn")},

        /// hendelseslogg Gruppe-1-X-språk
        'Gruppe-1-X-språk': {datatype: Datatype.spraak, feltOversettelse: this.gettextCatalog.getString("Språk")},
        /// hendelseslogg Gruppe-1-X-tillatteAutentiseringsmetoder
        'Gruppe-1-X-tillatteAutentiseringsmetoder': {datatype: Datatype.tillatteAutentiseringsmetoder, feltOversettelse: this.gettextCatalog.getString("Tillatte autentiseringsmetoder")},

        /// hendelseslogg Møtedeltaker-1-X-status
        'Møtedeltaker-1-X-status': {datatype: Datatype.deltakerstatus, feltOversettelse: this.gettextCatalog.getString("Deltakerstatus")},
        'Møtedeltaker-1-7-stemming': {datatype: Datatype.skip, feltOversettelse: "skjules"},
        'Møtedeltaker-1-8-stemming': {datatype: Datatype.skip, feltOversettelse: "skjules"},

        /// hendelseslogg ProtokollførtMøtedeltaker-1-X-skalSignere
        'ProtokollførtMøtedeltaker-1-X-skalSignere': {datatype: Datatype.boolean, feltOversettelse: this.gettextCatalog.getString("Signere")},
        /// hendelseslogg ProtokollførtMøtedeltaker-1-X-kommentar
        'ProtokollførtMøtedeltaker-1-X-kommentar': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Kommentar")},
        /// hendelseslogg ProtokollførtMøtedeltaker-1-X-status
        'ProtokollførtMøtedeltaker-1-X-status': {datatype: Datatype.protokollfortDeltakerstatus, feltOversettelse: this.gettextCatalog.getString("Status")},

        /// hendelseslogg Avstemning-1-X-beskrivelse
        'Avstemning-1-X-beskrivelse': {datatype: Datatype.html, feltOversettelse: this.gettextCatalog.getString("Beskrivelse")},
        /// hendelseslogg Avstemning-1-X-tittel
        'Avstemning-1-X-tittel': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Tittel")},
        /// hendelseslogg Avstemning-1-X-alternativer
        'Avstemning-1-X-alternativer': {datatype: Datatype.avstemningalternativer, feltOversettelse: this.gettextCatalog.getString("Alternativer")},
        /// hendelseslogg Avstemning-1-10-åpentForStemmegiving
        'Avstemning-1-10-åpentForStemmegiving': {datatype: Datatype.boolean, feltOversettelse: this.gettextCatalog.getString("Stemming åpent")},
        'Avstemning-1-9-åpentForStemmegiving': {datatype: Datatype.boolean, feltOversettelse: this.gettextCatalog.getString("Stemming åpent")},

        /// hendelseslogg Arkivnode-1-X-navn
        'Arkivnode-1-X-navn': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Mappenavn")},
        /// hendelseslogg Arkivnode-1-X-beskrivelse
        'Arkivnode-1-X-beskrivelse': {datatype: Datatype.html, feltOversettelse: this.gettextCatalog.getString("Beskrivelse")},

        /// hendelseslogg Tema-1-X-beskrivelse
        'Tema-1-X-beskrivelse': {datatype: Datatype.html, feltOversettelse: this.gettextCatalog.getString("Beskrivelse")},
        /// hendelseslogg Tema-1-X-navn
        'Tema-1-X-navn': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Navn")},
        /// hendelseslogg Tema-1-X-status
        'Tema-1-X-status': {datatype: Datatype.temastatus, feltOversettelse: this.gettextCatalog.getString("Status")},

        /// hendelseslogg Årshjulinnslag-1-X-startuke
        'Årshjulinnslag-1-X-startuke': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Startuke")},
        /// hendelseslogg Årshjulinnslag-1-X-antallUker
        'Årshjulinnslag-1-X-antallUker': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Antall uker")},
        /// hendelseslogg Årshjulinnslag-1-X-beskrivelse
        'Årshjulinnslag-1-X-beskrivelse': {datatype: Datatype.html, feltOversettelse: this.gettextCatalog.getString("Beskrivelse")},
        /// hendelseslogg Årshjulinnslag-1-X-tittel
        'Årshjulinnslag-1-X-tittel': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Tittel")},

        /// hendelseslogg Sakstype-1-X-navn
        'Sakstype-1-X-navn': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Navn")},

        /// hendelseslogg MedlemsRolle-1-X-tittel
        'MedlemsRolle-1-X-tittel': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Tittel")},

        ///Plan-1-X-førsteMøtenummer
        'Plan-1-X-førsteMøtenummer': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Første møtenummer")},

        ///Plan-1-X-førsteSaksnummer
        'Plan-1-X-førsteSaksnummer': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Første saksnummer")},

        ///Signatar-1-3-harSignert
        'Signatar-1-3-harSignert': {datatype: Datatype.boolean, feltOversettelse: this.gettextCatalog.getString("Signert")},

        // Aksjeeier i aksjeeierbok
        'Aksjeeier-1-X-representertAv': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Representert av")},
        'Aksjeeier-1-X-organisasjonsnummer': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Organisasjonsnummer")},
        'Aksjeeier-1-X-adresse': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Adresse")},
        'Aksjeeier-1-X-navn': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Navn")},
        'Aksjeeier-1-X-fødselsdato': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Fødselsdato")},
        'Aksjeeier-1-X-epost': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("E-post")},
        'Aksjeeier-1-X-type': {datatype: Datatype.aksjeeiertype, feltOversettelse: this.gettextCatalog.getString("Type")},

        /// Hendelseslogg aksjebeholdning
        'Aksjebeholdning-1-X-kommentar': {datatype: Datatype.html, feltOversettelse: this.gettextCatalog.getString("Kommentar")},
        'Aksjebeholdning-1-X-aksjeklasse': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Aksjeklasse")},
        'Aksjebeholdning-1-X-aksjenummerSamling': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Aksjenummer")},

        /// Hendelseslogg aksjeklasse
        'Aksjeklasse-1-X-arkivert': {datatype: Datatype.boolean, feltOversettelse: this.gettextCatalog.getString("Arkivert")},
        'Aksjeklasse-1-X-beskrivelse': {datatype: Datatype.html, feltOversettelse: this.gettextCatalog.getString("Beskrivelse")},
        'Aksjeklasse-1-X-navn': {datatype: Datatype.standard, feltOversettelse: this.gettextCatalog.getString("Navn")},

        /// Hendelseslogg spørreundersøkelse
        'Spørreundersøkelse-1-32-responsperiode': {datatype: Datatype.datoPeriode, feltOversettelse: this.gettextCatalog.getString("Responsperiode")},
        'Spørreundersøkelse-1-31-responsperiode': {datatype: Datatype.datoPeriode, feltOversettelse: this.gettextCatalog.getString("Responsperiode")},

    }

    hentDatatypeOgOVersettelse(nøkkel: string, felt: string): FeltEndringMedDataTypeOgOversettelse {
        let datatypeOgOversettelse = this.datatyperOgOversettelser[nøkkel];
        if (datatypeOgOversettelse != null) return datatypeOgOversettelse;
        console.log("Mangler datatype og oversettelse for nøkkel: ", nøkkel);
        return {datatype: Datatype.standard, feltOversettelse: felt};
    }


    lastEpostMottaker(modell: Modell, callback: (epostMottaker: EpostMottaker) => void) {
        if (modell.hendelse.entitetReferanse.type === 'Bruker') {
            if (modell.hendelse.gruppeId)
                this.gruppeRes.medlemMedBrukerId(modell.hendelse.gruppeId, modell.hendelse.entitetReferanse.id).$promise
                  .then(medlem => callback(this.medlemTilEpostMottaker(medlem)))
                  // svelg disse feilene, manga ganger sååer ikk emdelm opprettet enn, når det er sendt invitasjon til en eksisterede bruker. 
                  .catch(reason => {});
            else {
                // Melding er sendt til bruker, men ikke å vegne av 1 gruppe, mest sannsynlig flere grupper.
                // typisk oppgaver/signaturer på tvers av gruppene.
                // antar at hvsi an kan se hendelsen, så har man også tilgang på bruker. Er kun superadmin og bruker selv som kan se disse.
                this.brukerRes.hent(modell.hendelse.entitetReferanse.id).$promise
                    .then(bruker => callback( this.brukerTilEpostMottaker(bruker)))
            }
        }
        if (this.modell.hendelse.entitetReferanse.type === 'Medlem') {
            // medlem kan være slettet.
            this.medlemRes.hent(modell.hendelse.entitetReferanse.id, _.noop, feil => {
                console.log("FEIL", feil)
                if (feil.status === 410) // gone
                    return true // viser ikke feilmelding
                return false; // viser feilmelding
            }).$promise
                .then(medlem => callback(this.medlemTilEpostMottaker(medlem)));
        }
    }

    lastMøteNavn(gruppeId:string, callback:(møteNavn:string) => void) {
        this.gruppeRes.hent(gruppeId).$promise.then(g => callback (g.moetenavn));
    }

}

class FeltEndringMedDataTypeOgOversettelse {
    datatype: Datatype;

    feltOversettelse: string;
}

enum Datatype {
    datoPeriode,
    html,
    dato,
    varighet,
    boolean,
    medlemmer,
    /** {@link l.Invitasjonsstatus} */
    invitasjonsstatus,
    /** {@link l.Medlemstatus} */
    medlemstatus,
    /** {@link l.Deltakerstatus} */
    deltakerstatus,
    /** {@link l.Oppgavestatus} */
    oppgavestatus,
    protokollfortDeltakerstatus,
    avstemningalternativer,
    moete,
    tilgangsroller,
    signeringsstatus,
    standard,
    spraak,
    temastatus,
    tillatteAutentiseringsmetoder,
    // l.Aksjeeiertype
    aksjeeiertype,
    skip,  // vises ikke
}

interface EpostMottaker {
    // ikke alltid satt
    gruppeId: string;
    // ikke alltid satt
    medlemId: string;
    // alltid satt
    brukerId: string;
    // bruker.epost eller meldem.epost
    epost: string;
    // bruker.navn eller meldlem.navn
    navn: string;
}

class Modell {
    private static sp2Subendringstyper = [l.SubEndringstype.sp2Endringshendelse, l.SubEndringstype.sp2SignEndringshendelse, l.SubEndringstype.sp2SmsEndringshendelse];
    private _initDetaljerKjørt: boolean = false;
    private epostUrl: string = null; // settes kun hvis dette er en epost. settes når detaljer vises.

    visDetaljer: boolean = false;
    harFeltendringer: boolean;
    erEpost: boolean;
    ikonType: string;
    stoetterGaaTil: boolean; // kan endre verdi, etter at epostMottaker er funnet
    felter: FeltModell[] = []
    moetenavn: string; // lastes kun for de hendelser som trenger den. per nå er det kun for å hente gruppe.møtenavn når sak flyttes til annet møte.
    epostMottaker: EpostMottaker = null; // settes kun hvis dette er en epost.
    erSp2Melding = false;

    constructor(public hendelse: l.EndringshendelseModell) {
    }

    init(ctrl: EndringshendelseKontroller) {
        this.erEpost = this._isEpost();
        this.ikonType = this._ikonType();

        if (this.erEpost) {
            const self = this;
            ctrl.lastEpostMottaker(this, epostMottaker => {
                self.epostMottaker = epostMottaker;
                // må kalles på nytt da en kan endre verdi når epostMottaker er satt
                self.stoetterGaaTil = self._stoetterGaaTil();
            });
        }
        this.stoetterGaaTil = this._stoetterGaaTil();
        this.erSp2Melding = _.includes(Modell.sp2Subendringstyper,this.hendelse.subEndringstype);
        //if (this.erSp2Melding && this.hendelse.beskrivelse.noeklerOgVerdier['detailed'])
        //    console.log("##### HAR DETAIL ", this.hendelse.beskrivelse.noeklerOgVerdier)
    }

    initDetaljer(ctrl: EndringshendelseKontroller) {
        if (this._initDetaljerKjørt) return;
        this._initDetaljerKjørt = true;

        this.harFeltendringer = this._harFeltendringer();
        if (this.harFeltendringer) {
            for (const felt of this._felterMedEndring()) {
                this.felter.push(new FeltModell(felt, this.feltEndringsNøkkel(felt), this.feltEndring(felt), ctrl))
            }
        }

        if (this._trengerLasteGruppe()) {
            ctrl.lastMøteNavn(this.hendelse.gruppeId, møteNavn => this.moetenavn = møteNavn);
        }

        if (this.erEpost) {
            const blob = this.erSp2Melding ?
                new Blob(
                    [this.hendelse.beskrivelse.noeklerOgVerdier.beskrivelse.detailed],
                    {type: 'text/html;charset=UTF-8'}
                ) :
                new Blob(
                    [this.hendelse.beskrivelse.noeklerOgVerdier.beskrivelse.htmlKropp],
                    {type: 'text/html;charset=UTF-8'}
                );
            this.epostUrl = URL.createObjectURL(blob);
            ctrl.setEpostIframeSrc(this.hendelse.id, this.epostUrl);
        }
    }

    private _felterMedEndring(): string[] {
        return Object.keys(this.hendelse.beskrivelse.noeklerOgVerdier.feltendringer);
    }

    private _trengerLasteGruppe(): boolean {
        // flytting av sak til møte
        if (this.hendelse.beskrivelse.malnavn === "endringshendelse-Sak-1-0") return true;
        return false;
    }


    private _isEpost(): boolean {
        if (this.hendelse.endringstype === l.Endringstype.epost) return true;
        return false;
    }

    private _ikonType(): string {
        if (this.erEpost) return "epost";
        return this.hendelse.entitetReferanse.type;
    }

    private _stoetterGaaTil(): boolean {
        //kan ikke navigere til slettede entiteter
        if (this.hendelse.endringstype === l.Endringstype.slett) return false;
        if (this.erEpost) {
            if (this.epostMottaker === null) return false;
            if (this.epostMottaker.gruppeId === null || this.epostMottaker.medlemId === null) return false;
            return true;
        }
        if (this.hendelse.entitetReferanse.type.toLowerCase() === "arkivnode") return false; // Arkivnode støttes ikke nå, Vet  ikke om det er filnode eller mappenode.
        if (this.hendelse.entitetReferanse.type.toLowerCase() === "signatar") return false; // Signatar støttes ikke nå -> bør gå til møte. 
        return !_.isNil(this.hendelse.entitetReferanse);
    }

    private _harFeltendringer(): boolean {
        if (this.hendelse.beskrivelse == null) return false;
        if (this.hendelse.beskrivelse.noeklerOgVerdier == null) return false;
        if (this.hendelse.beskrivelse.noeklerOgVerdier.feltendringer == null) return false;
        if (Object.keys(this.hendelse.beskrivelse.noeklerOgVerdier.feltendringer).length == 0) return false;
        return true;
    }

    private feltEndringsNøkkel(felt: string): string {
        return `${this.hendelse.entitetReferanse.type}-${this.hendelse.endringstype}-${this.hendelse.subEndringstype ?? 'X'}-${felt}`;
    }

    private feltEndring(felt: string): l.FeltendringModell {
        return this.hendelse.beskrivelse.noeklerOgVerdier.feltendringer[felt];
    }

    onDestroy() {
        URL.revokeObjectURL(this.epostUrl)
    }
}

class FeltModell {

    skrivesSomStandard: boolean;
    datatype: Datatype;
    feltOversettelse: string;
    gammelVerdi: any
    nyVerdi: any

    // for html
    htmlDiff: string
    visGammelOgNy: boolean = false;

    // for datoPeriode
    startDatoEndret: boolean;
    sluttDatoEndret: boolean;
    gammelVerdiStart: string
    nyVerdiStart: string
    gammelVerdiSlutt: string
    nyVerdiSlutt: string

    constructor(felt: string, feltEndringsNøkkel: string, feltendring: l.FeltendringModell, ctrl: EndringshendelseKontroller) {

        const endringMedDataTypeOgOversettelse = ctrl.hentDatatypeOgOVersettelse(feltEndringsNøkkel, felt);
        this.datatype = endringMedDataTypeOgOversettelse.datatype;
        this.feltOversettelse = endringMedDataTypeOgOversettelse.feltOversettelse;
        this.skrivesSomStandard = this._skrivesSomStandard();
        ctrl.hentGammelOgNyVerdi(this.datatype, feltendring, (gammelVerdi, nyVerdi) => {
            this.gammelVerdi = gammelVerdi;
            this.nyVerdi = nyVerdi;
        });
        if (this.datatype === Datatype.html) {
            this.htmlDiff = ctrl.htmlDiff(feltendring.gammelVerdi, feltendring.nyVerdi);
        }

        if (this.datatype === Datatype.datoPeriode) {
            this.startDatoEndret = this._startDatoEndret();
            this.sluttDatoEndret = this._sluttDatoEndret();
            this.gammelVerdiStart = EndringshendelseKontroller.formaterDatoOgKlokkeslett(this.gammelVerdi?.start);
            this.gammelVerdiSlutt = EndringshendelseKontroller.formaterDatoOgKlokkeslett(this.gammelVerdi?.slutt);
            this.nyVerdiStart = EndringshendelseKontroller.formaterDatoOgKlokkeslett(this.nyVerdi?.start);
            this.nyVerdiSlutt = EndringshendelseKontroller.formaterDatoOgKlokkeslett(this.nyVerdi?.slutt);
        }
    }

    seGammelOgNyForHtml() {
        this.visGammelOgNy = true;
    }

    seDiffForHtml() {
        this.visGammelOgNy = false;
    }

    private _skrivesSomStandard(): boolean {
        return [
            Datatype.standard,
            Datatype.boolean,
            Datatype.dato,
            Datatype.deltakerstatus,
            Datatype.invitasjonsstatus,
            Datatype.medlemstatus,
            Datatype.oppgavestatus,
            Datatype.temastatus,
            Datatype.signeringsstatus,
            Datatype.protokollfortDeltakerstatus,
            Datatype.spraak,
            Datatype.aksjeeiertype
        ].includes(this.datatype);
    }

    private _startDatoEndret(): boolean {
        return EndringshendelseKontroller.datoEndret(this.gammelVerdi?.start, this.nyVerdi?.start);
    }

    private _sluttDatoEndret(): boolean {
        return EndringshendelseKontroller.datoEndret(this.gammelVerdi?.slutt, this.nyVerdi?.slutt);
    }
}

